import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import httpClient from "./httpClient";
import {ReactComponent as Link} from "../svgs/link.svg";
import {ReactComponent as OK} from "../svgs/V.svg";
import {ReactComponent as Delete} from "../svgs/X.svg";
import {PATH as PATH} from "../paths";

export const YandexSortComponent = ({token, doc, verify}) => {
    const [access, setAccess] = useState("")
    const [docID, setDocID] = useState(null)
    const [sort_, setSort_] = useState(false)
    const [isSorted, setIsSorted] = useState(false)
    const [yadFolder, setYadFolder] = useState(null)
    const [error, setError] = useState(false)
    const [taskId, setTaskId] = useState(null)
    const [taskStatus, setTaskStatus] = useState(null)

    useEffect(() => {
        setAccess(token)
    }, [token])

    useEffect(() => {
        setDocID(doc)
    }, [doc])

    // Эффект для опроса статуса задачи
    useEffect(() => {
        let intervalId = null

        if (taskId && sort_) {
            intervalId = setInterval(async () => {
                try {
                    const res = await httpClient.get(`${PATH}/api/yad/status?id=${taskId}`, {
                        headers: {
                            Authorization: access
                        }
                    })

                    const statusData = res.data
                    setTaskStatus(statusData)

                    // Если задача завершена - прекращаем опрос
                    if (statusData.state === 'success') {
                        setSort_(false)
                        setIsSorted(true)
                        setYadFolder(statusData.details?.url)
                        clearInterval(intervalId)
                    }

                    // Если задача завершилась ошибкой - прекращаем опрос
                    if (statusData.state === 'FAILURE') {
                        setSort_(false)
                        setError(statusData.message || 'Произошла ошибка при сортировке')
                        clearInterval(intervalId)
                    }

                } catch (e) {
                    console.error('Ошибка при проверке статуса задачи:', e)
                    if (e.response?.status === 401) {
                        verify()
                        clearInterval(intervalId)
                    }
                }
            }, 2000) // Опрос каждые 2 секунды
        }

        // Очистка интервала при размонтировании
        return () => {
            if (intervalId) {
                clearInterval(intervalId)
            }
        }
    }, [taskId, sort_, access, verify])

    const sortSubmit = async () => {
        try {
            setSort_(true)
            setIsSorted(false)
            setError(false)
            setTaskStatus(null)

            const res = await httpClient.get(`${PATH}/api/yad/sort?spreadsheet_id=${docID}`, {
                headers: {
                    Authorization: access
                }
            })

            // Если бэкенд возвращает task_id
            if (res.data.state === 'processing' && res.data.details?.task_id) {
                setTaskId(res.data.details.task_id)
            } else {
                // Если бэкенд работает синхронно
                setSort_(false)
                setIsSorted(true)
                setYadFolder(res.data.details?.url)
            }

        } catch (e) {
            setSort_(false)
            if (e.response?.status === 401) {
                verify()
            } else {
                setError(e.response?.data?.message || 'Произошла ошибка')
            }
            console.error(e.response?.data || e)
        }
    }

    const navigate = useNavigate()

    if (!access) {
        return (
            <div className="docBlock block"></div>
        )
    } else if (!docID) {
        return (
            <div className="docBlock block"></div>
        )
    } else {
        return (
            <div className='yadSortedBlock'>
                {!sort_ ? (
                    <div className='buttonWithSpinner'>
                        <button
                            className="btnsHolder clearBtn linkHolder docLink"
                            type="button"
                            onClick={sortSubmit}
                            disabled={sort_}
                        >
                            Отсортировать фотографии
                        </button>
                    </div>
                ) : (
                    <div className='buttonWithSpinner'>
                        <button
                            className="btnsHolder clearBtn linkHolder docLink"
                            type="button"
                            disabled
                        >
                            Идет сортировка фотографий
                        </button>
                        <div className='spinner'/>
                    </div>
                )}

                {taskStatus && (
                    <div className='sortState'>
                        <div className="task-status">
                            {taskStatus.status}
                        </div>
                    </div>
                )}

                {/* Результат */}
                <div className='sortState'>
                    {error ? (
                        <div className='errorMsg errorYadFolder'>
                            {error}
                        </div>
                    ) : isSorted ? (
                        <div className="success-message">
                            <span>Фотографии отсортированы</span>
                        </div>
                    ) : (
                        <div className='status-placeholder'></div>
                    )}
                </div>
            </div>
        )
    }
}